import { render, staticRenderFns } from "./IotAlertListForPerson.vue?vue&type=template&id=3b546bec&scoped=true&"
import script from "./IotAlertListForPerson.vue?vue&type=script&lang=js&"
export * from "./IotAlertListForPerson.vue?vue&type=script&lang=js&"
import style0 from "./IotAlertListForPerson.vue?vue&type=style&index=0&id=3b546bec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b546bec",
  null
  
)

export default component.exports